import { type ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { LogoLoader } from "@libs/zapi-ui/custom";
import { useAuthenticated } from "@/zapi-admin/shared/hooks/useAuthenticated";
import { getRouteSignIn } from "@/zapi-admin/shared/const/router";
import { useHistoricalNavigate } from "@/zapi-admin/shared/hooks/useHistoricalNavigate";
import { AppNavbar } from "@/zapi-admin/shared/components/AppNavbar/ui/AppNavbar";
import { AppFooter } from "@/zapi-admin/shared/components/AppFooter/AppFooter";

type TProps = {
  children: ReactElement;
};

export function ProtectedRoute({ children }: TProps) {
  const { navigate } = useHistoricalNavigate();
  const { isAuthenticated, isLoading } = useAuthenticated();
  const { pathname, search } = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-svh items-center justify-center">
        <LogoLoader label="Loading" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const nextNav = pathname + search;
    navigate(getRouteSignIn() + `?next=${encodeURIComponent(nextNav)}`);
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <AppNavbar />
      <div className="bg-zinc-100 flex-1">{children}</div>
      <AppFooter />
    </div>
  );
}
